import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import FloatingWhatsAppCTA from "./components/feature/FloatingWhatsAppCTA";

// Affiché pendant le chargement du chunk d'une page (code-splitting par route).
function PageLoader() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <span className="ri-loader-4-line" style={{ fontSize: 32, animation: "spin 1s linear infinite" }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <Suspense fallback={<PageLoader />}>
          <AppRoutes />
        </Suspense>
        <FloatingWhatsAppCTA />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;